<template>
  <div>
    <label v-if="label">{{ label }}</label>
    <textarea
      :class="['input', { readonly }]"
      :id="id"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :rows="rows"
      :minlength="minlength"
      :maxlength="maxlength"
      v-on="inputListeners"
    />
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    label: String,
    value: [String, Number],
    rows: [String, Number],
    minlength: [String, Number],
    maxlength: [String, Number],
    readonly: [String, Boolean],
    disabled: [String, Boolean],
    required: [String, Boolean],
    placeholder: String
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.$emit("input", event.target.value);
        }
      };
    }
  }
};
</script>

<style scoped lang="scss">
.input {
  box-sizing: border-box;
  display: block;
  flex: 1 1 auto;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: var(--input-height);
  max-height: 100vh;
  padding: var(--input-padding-bordered);
  font-size: 1rem;
  line-height: var(--input-line-height);
  color: var(--text-color-base);
  background: var(--input-default-background);
  border: var(--input-border);
  border-radius: var(--input-border-radius);
  transition: border-color 200ms cubic-bezier(0.645, 0.045, 0.355, 1);
}
.readonly {
  background: transparent;
}
</style>
